// extracted by mini-css-extract-plugin
export var container = "_bo-0";